"use client";
import React, { useEffect, useState } from "react";
import { Empty, Pagination, Select, Spin } from "antd";
import { ArrowLeft, ArrowRight } from "lucide-react";
import CommonImage from "@/components/common/image/CommonImage";
import CommonService from "@/services/api/CommonService";
import { useParams, useRouter } from "next/navigation";

import { IoChevronDown } from "react-icons/io5";
import BlogCard from "./components/BlogCard";
import { Button, Drawer, Radio, Space } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { FaList } from "react-icons/fa6";

export default function BlogPage() {
  const params = useParams();
  const router = useRouter();
  const { categorySlug } = params;
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(true);
  const [blogs, setBlogs] = useState([]);
  const [page, setPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [title, setTitle] = useState(null);

  useEffect(() => {
    fetchBlogCategory();
  }, []);

  const fetchBlogCategory = async () => {
    try {
      const getBlogCategory = await CommonService.getblogCategory();
      setCategories(getBlogCategory);
      // if (getBlogCategory.length > 0) {
      //   setSelectedCategory(response[0].id);
      // }
    } catch (err) {
      console.error("Failed to load Category", err);
    }
  };
  //  console.log(currentPage);
  useEffect(() => {
    if (selectedCategory) {
      fetchResults(currentPage);
    } else {
      fetchResults(currentPage);
    }
  }, [selectedCategory, currentPage]);

  const fetchResults = async (page) => {
    // console.log("page", page);
    setLoading(true);
    try {
      const response = await CommonService.getBlogs({
        category_id: selectedCategory,
        title: title,
        page: page,
      });
      const resData = response;
      // console.log("blogs", resData);
      setBlogs(resData.data || []);
      setTotalItems(resData.total || 0);
      setPageSize(resData.per_page || 10);
      setLoading(false);
    } catch (err) {
      console.error("Failed to fetch results", err);
    } finally {
      setLoading(false);
    }
  };

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    setTitle(null);
    setPage(1);
    setCurrentPage(1);
  };

  const [open, setOpen] = useState(false);
  const [placement, setPlacement] = useState('left');
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  return (
    <section className="blog_section section_padding-48">
      <div className="container">
        <div className="fa-card blog-wrap">
          <div className="section_title">
            <h2 className="title">
              <span className="w-8 h-8">
                <CommonImage
                  src="/images/icon/blog-section-icon.avif"
                  className="img-icon"
                  alt="icon"
                />
              </span>{" "}
              আমাদের ব্লগ সমূহ
            </h2>
            <p className="short-des">
              ফোকাস - যেখানে একাডেমিক সাফল্যের পথ তৈরি হয়। অভিজ্ঞ শিক্ষকদের
              গাইডলাইন, নিয়মিত পরীক্ষার ব্যবস্থা এবং টপিকভিত্তিক অনুশীলনের
              মাধ্যমে আমরা গড়ে তুলি ভবিষ্যতের চ্যাম্পিয়ন।
            </p>
          </div>
          <div className="blog-content-wrap section-content-wrap">
            <div className="grid grid-cols-12 md:gap-6 gap-4">
              <div className="xl:col-span-3 col-span-12">
                <div className="blog-side-bar">
                  <Button className="filtering-btn" onClick={showDrawer}>
                    <FaList/>
                  </Button>
                  <div className="md:space-y-6 space-y-4 hidden xl:block">
                    {/* সার্চ বক্স সেকশন */}
                    <div className="sidebar-card">
                      <h3 className="title">সার্চ করো</h3>
                      <div className="search-btn">
                        <input
                          type="text"
                          placeholder="সার্চ করো"
                          className="input-btn"
                          value={title || ""}
                          onChange={(e) => setTitle(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key == "Enter") {
                              setCurrentPage(1);
                              fetchResults(1);
                            }
                          }}
                        />
                        <button
                          className="search-submit-btn"
                          onClick={() => {
                            setCurrentPage(1);
                            fetchResults(1);
                          }}
                        >
                          <svg
                            className="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M21 21l-4.35-4.35M11 19a8 8 0 100-16 8 8 0 000 16z"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>

                    {/* ব্লগ ক্যাটেগরি সেকশন */}
                    <div className="sidebar-card">
                      <h3 className="title">ব্লগ ক্যাটাগরি</h3>

                      <ul className="space-y-4">
                        {categories?.map((item, index) => (
                          <li
                            key={index}
                            onClick={() => handleCategoryClick(item.id)}
                          >
                            <button className="search-item-btn">
                              <span>{item.title}</span>
                              {/* <span>{item.blogs_count}</span> */}
                            </button>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="xl:col-span-9 col-span-12">
                <div className="grid xl:grid-cols-3 grid-cols-2 md:gap-6 gap-4">
                  {loading ? (
                    <div className="flex items-center justify-center h-[200px] w-full col-span-full">
                      <Spin size="large" />
                    </div>
                  ) : blogs.length > 0 ? (
                    blogs.map((blog, i) => (
                      <BlogCard key={i} blog={blog}></BlogCard>
                    ))
                  ) : (
                    <div className="col-span-full">
                      <Empty description="No Blog available" />
                    </div>
                  )}
                </div>
                {/* Pagination */}
                {totalItems > pageSize && (
                  <div className="fa-pagination">
                    <Pagination
                      current={currentPage}
                      pageSize={pageSize}
                      total={totalItems}
                      onChange={(page) => setCurrentPage(page)}
                      showSizeChanger={false}
                      itemRender={(page, type, originalElement) => {
                        if (type === "prev") {
                          return (
                            <a className="">
                              <ArrowLeft />
                            </a>
                          );
                        }
                        if (type === "next") {
                          return (
                            <a className="">
                              <ArrowRight />
                            </a>
                          );
                        }
                        return originalElement;
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Drawer
        closable={false}
        onClose={onClose}
        open={open}
        placement={placement}
        key={placement}
        className= 'blog-catagory-search'
      >
        {/* Custom Header */}
        <div className="sidebar-header">
          <Button
            type="text"
            icon={<CloseOutlined style={{ fontSize: '16px' }} />}
            onClick={onClose}
          />
        </div>

        {/* Body Content */}
        <div>
          <div className="blog-side-bar">
            <div className="md:space-y-6 space-y-4">
              {/* সার্চ বক্স সেকশন */}
              <div className="sidebar-card">
                <h3 className="title">সার্চ করো</h3>
                <div className="search-btn">
                  <input
                    type="text"
                    placeholder="সার্চ করো"
                    className="input-btn"
                    value={title || ""}
                    onChange={(e) => setTitle(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key == "Enter") {
                        setCurrentPage(1);
                        fetchResults(1);
                      }
                    }}
                  />
                  <button
                    className="search-submit-btn"
                    onClick={() => {
                      setCurrentPage(1);
                      fetchResults(1);
                    }}
                  >
                    <svg
                      className="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M21 21l-4.35-4.35M11 19a8 8 0 100-16 8 8 0 000 16z"
                      />
                    </svg>
                  </button>
                </div>
              </div>

              {/* ব্লগ ক্যাটেগরি সেকশন */}
              <div className="sidebar-card">
                <h3 className="title">ব্লগ ক্যাটাগরি</h3>

                <ul className="space-y-4">
                  {categories?.map((item, index) => (
                    <li
                      key={index}
                      onClick={() => handleCategoryClick(item.id)}
                    >
                      <button className="search-item-btn">
                        <span>{item.title}</span>
                        {/* <span>{item.blogs_count}</span> */}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Drawer>




    </section>
  );
}
